<template>
  <div class="mb-8">
    <Headline class="mb-8" title="Reservierung der Kautionsbürgschaft" alignment="text-left"/>
    <div class="space-y-4">

      <p class="text-gray-500">Sie suchen momentan eine Wohnung und haben noch keinen Mietvertrag unterschrieben? Dann
        können Sie einfach und unkompliziert eine Reservierung der Mietkautionsbürgschaft für einen Monat beantragen –
        und
        das komplett <span class="font-bold"> kostenlos und unverbindlich.</span></p>
      <div class="sm:hidden flex">
        <a href="#beginnform"
           class="w-full text-center whitespace-nowrap text-sm font-medium border border-transparent rounded-full text-white bg-green-400 px-4 py-3 hover:bg-green-300 ">Direkt
          zum Formular</a>
      </div>
      <p class="text-green-400"> Und so einfach funktioniert's:</p>

      <div class="prose text-gray-500">
        <ul>
          <li>Füllen Sie das nachfolgende Formular aus.</li>
          <li> Beim Absenden des Formulars führen wir eine Prüfung der Bonität durch.</li>
          <li>Nach erfolgreicher Bonitätsprüfung senden wir Ihnen sofort Ihre Reservierungszusage per E-Mail zu.</li>
          <li>Die Zusage können Sie sich ausdrucken und Ihrem Vermieter bereits bei der Wohnungsbesichtigung präsentieren.
          </li>
        </ul>
      </div>

      <p class="text-gray-500">
        Bei einer Wohnungszusage können Sie Ihre Reservierung innerhalb von einem Monat ab Reservierungszusage in eine
        aktive Bürgschaft umwandeln.
      </p>
      <p class="text-gray-500">
        Da es sich hier um eine unverbindliche Reservierung handelt, verfällt diese automatisch und kostenlos nach einem
        Monat. Sie können jederzeit eine neue Reservierung vornehmen.
      </p>

    </div>
  </div>
</template>

<script setup>
import Headline from "../../common/components/Headline";

</script>
